<template>
  <article class="container text-left py-5">
    <h1>The Interactive Meme Series</h1>
    <p>{{ $route.path.startsWith('/zh/') ? '吳哲宇的互動迷因作品，以下保留原版收藏名稱與平台連結。' : 'Interactive meme works by Che-Yu Wu, with their original collection links.' }}</p>
    <section class="py-4">
      <h2>Hamily × The Memes by 6529 × Che-Yu Wu</h2>
      <p>Season 2, Card 2 · 2023/3/2 · 690 editions</p>
      <!-- 2026-09-20：19 MB 的 GIF 換成 R2 上的 13 秒 mp4（同一段畫面）；海報用本地靜幀 -->
      <video class="w-100" src="https://media.cheyuwu.com/work/strange-robot/827bd09a-wagmi.mp4" poster="/static/img/memes-6529/cover-2026-09.jpg" muted loop autoplay playsinline preload="metadata" aria-label="The Hamily WAGMI"></video>
      <p><router-link :to="($route.path.startsWith('/zh/') ? '/zh' : '') + '/work/memes-6529/'">{{ $route.path.startsWith('/zh/') ? '作品頁：這張卡從哪來 →' : 'Work page: where this card comes from →' }}</router-link></p>
      <p><a href="https://opensea.io/assets/ethereum/0x33fd426905f149f8376e227d0c9d3340aad17af1/74" target="_blank" rel="noopener noreferrer">View the original collection ↗︎</a></p>
    </section>
    <section class="py-4">
      <h2>230206 MEMEGINEERING</h2>
      <p>Che-Yu Wu Interactive Memes · 2023 · 420 editions</p>
      <p>Interactive works bringing animation and participation into the meme format.</p>
      <a href="https://app.manifold.xyz/c/230206-Memegineering" target="_blank" rel="noopener noreferrer">View the original collection ↗︎</a>
    </section>
  </article>
</template>
